import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  height: 100vh;\n  width: 100vw;\n  background-color: transparent;\n  opacity: 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
var NavigationOverlay = styled.div.withConfig({
    componentId: "sc-1e474eaa-0"
})(_templateObject(), function(props) {
    return props.$isActive ? "all" : "none";
});
export default NavigationOverlay;
